var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 4.72708L5.60193 6.81566C5.60211 6.81574 5.6023 6.81581 5.60249 6.81589C6.60602 7.2198 7.72692 7.21977 8.73044 6.81578C8.73053 6.81574 8.73063 6.8157 8.73073 6.81566L13.9583 4.7245V9.832C13.9574 10.5722 13.6629 11.2819 13.1395 11.8053C12.6161 12.3287 11.9064 12.6232 11.1662 12.6241H3.16714C2.4269 12.6232 1.71725 12.3287 1.19383 11.8053C0.670457 11.2819 0.375994 10.5724 0.375 9.83222V4.72708Z",
    stroke: "#161616",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25433 5.19283L6.25348 5.19249L0.885206 3.04478L0.416441 2.77137C0.504582 2.14856 0.801389 1.57134 1.2618 1.13629C1.77707 0.649397 2.45851 0.377167 3.16741 0.375H11.1663C11.8752 0.377167 12.5566 0.649397 13.0719 1.13629C13.5323 1.57134 13.8291 2.14856 13.9173 2.77137L13.4485 3.04478L8.07958 5.19248L8.07872 5.19283C7.49345 5.42863 6.8396 5.42863 6.25433 5.19283Z",
    stroke: "#161616",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.0cd3069c7f0287d3328df4b34723a937.svg";
export { ForwardRef as ReactComponent };